export const BIWEEKLY_REPORT_LIST_UI = [
  { key: 'createdAt', label: 'Fecha creación' },
  { key: 'createdBy', label: 'Creado por' },
  { key: 'startDate', label: 'Fecha desde' },
  { key: 'endDate', label: 'Fecha hasta' },
  { key: 'actions', label: 'Acciones' },
];

export const formatShortDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
